import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface OnboardingProps {
    merchant: { name: string; logo?: string };
    onContinue: () => void;
}

const Onboarding: React.FC<OnboardingProps> = ({ merchant, onContinue }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleContinue = async () => {
        setIsSubmitting(true);
        // Simulate a slight delay for better UX transition
        await new Promise(resolve => setTimeout(resolve, 500));
        onContinue();
    };

    return (
        <div className="tw-flex-1 tw-flex tw-flex-col">
            <div className="tw-text-center tw-space-y-6">
                <h1 className="tw-text-2xl tw-font-bold tw-text-gray-900">
                    Need help with your {merchant.name} product?
                </h1>

                <p className="tw-text-gray-600 tw-text-sm">
                    Manage your product details to access returns, protection, or warranty services. Your request will be handled as per {merchant.name}’s policies.
                </p>

                <div className="tw-bg-gray-50 tw-rounded-xl tw-p-6 tw-mt-8">
                    <h2 className="tw-font-semibold tw-text-gray-900 tw-mb-4">Here’s what you can do</h2>
                    <ul className="tw-space-y-3 tw-text-left tw-inline-block tw-text-sm tw-text-gray-700">
                        <li className="tw-flex tw-items-center tw-gap-2">
                            <span className="tw-w-1 tw-h-1 tw-bg-black tw-rounded-full"></span>
                            Add your product details
                        </li>
                        <li className="tw-flex tw-items-center tw-gap-2">
                            <span className="tw-w-1 tw-h-1 tw-bg-black tw-rounded-full"></span>
                            Access protection or warranty services
                        </li>
                        <li className="tw-flex tw-items-center tw-gap-2">
                            <span className="tw-w-1 tw-h-1 tw-bg-black tw-rounded-full"></span>
                            Request a product return
                        </li>
                        <li className="tw-flex tw-items-center tw-gap-2">
                            <span className="tw-w-1 tw-h-1 tw-bg-black tw-rounded-full"></span>
                            Track your request online
                        </li>
                    </ul>
                </div>
            </div>

            {/* Footer Action */}
            <div className="tw-mt-auto sm:tw-mt-8 tw-pt-6">
                <Button
                    onClick={handleContinue}
                    disabled={isSubmitting}
                    className="tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-2 tw-h-12 tw-bg-cyan-50 hover:tw-bg-cyan-100 tw-text-cyan-600 disabled:tw-text-gray-400 disabled:tw-bg-gray-100 tw-font-semibold tw-text-lg tw-rounded-lg tw-border-none tw-transition-colors"
                >
                    {isSubmitting && <Loader2 className="tw-w-5 tw-h-5 tw-animate-spin" />}
                    Continue
                </Button>
            </div>
        </div>
    );
};

export default Onboarding;
